import { useTranslation } from 'react-i18next';
import Icon from '../icon';
import { FieldsTooltip } from './FieldsTooltip';
import { COLORS } from '../../../constants';

const stopBubble = (e) => e.stopPropagation();

export const TooltipBlock = ({
    id,
    contentKey = id,
    icon,
    size = 24,
    className = 'modification__icon',
    place = 'top',
    fill = COLORS.BLACK,
    clickable = false,
    globalCloseEvents,
    positionStrategy,
}) => {
    const { t } = useTranslation();

    return (
        <div
            className={className}
            data-tooltip-id={id}
            data-tooltip-content={t(`${contentKey}`)}
            role="presentation"
            onClick={stopBubble}
            onTouchEnd={stopBubble}
            onPointerDown={stopBubble}
        >
            <Icon name={icon} size={size} fill={fill} />
            <FieldsTooltip
                id={id}
                place={place}
                clickable={clickable}
                globalCloseEvents={globalCloseEvents}
                positionStrategy={positionStrategy}
            />
        </div>
    );
};
